module.exports = __webpack_public_path__ + "static/media/Vedder_New.ff7ca194.jpg";